import { type Person, type PersonBaseBasicInformation } from 'services'
import React from 'react'
import { Avatar, Grid, IconButton, Link, Paper, Typography } from '@mui/material'
import PersonOffIcon from '@mui/icons-material/PersonOff'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { useSessionContext } from 'session'

export const PersonCard: React.FC<{
  person?: Person | PersonBaseBasicInformation
  handleEdit: () => void
  editable: boolean
  filledPerson: boolean
  pictureLink?: string
  showUniqueId?: boolean
  big?: boolean
}> = ({ person, handleEdit, editable, filledPerson, pictureLink, showUniqueId = false, big = false }) => {
  const { openNewTab } = useSessionContext()

  return (
        <Paper elevation={2} sx={{ p: 1, maxWidth: big ? '35vw' : '20vw' }}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={2}>
                    {(person != null) && (pictureLink != null ? <Avatar src={pictureLink} sx={{ height: '5' }}/> : <Avatar sx={{ height: '5' }}/>)}
                    {(person == null) && <PersonOffIcon/>}
                </Grid>
                <Grid item xs={8}>
                    {(person != null) &&
                        <Link component="button" variant="body2" underline={'hover'} onClick={() => {
                          if (person?.id != null) { openNewTab(`/editPerson/${person?.id}`) }
                        }}
                        >
                            <Typography variant="body1" sx={{ fontSize: 'inherit' }}>
                                {`${String(person.id)}${showUniqueId ? ` (${String('uniqueId' in person ? person.uniqueId : '')})` : ''} - ${person?.firstName ?? ''} ${person?.middleName ?? ''} ${person?.lastName}`}
                            </Typography>
                        </Link>
                    }
                    {(person == null) &&
                        <Typography variant="body1">
                            Vacant
                        </Typography>
                    }
                </Grid>
                {(filledPerson && editable) &&
                    <Grid item xs={1}>
                        <IconButton aria-label="Edit Logo" color="primary" onClick={handleEdit}>
                            <ManageAccountsIcon/>
                        </IconButton>
                    </Grid>
                }
            </Grid>
        </Paper>
  )
}
